/* eslint-disable react/no-danger */
import classnamesBind from 'classnames/bind';
import Link from '@concur/nui-widgets/Link';
import PropTypes from 'prop-types';
import React from 'react';
import { withFormatter } from '@concur/nui-intl-runtime';
import {
    withErrorBoundary, getDataCenter, compose,
} from '@concur/core-ui-shell';
import styles from './ServiceStatusLink.css';

const CSS_BLOCK = 'sapcnqr-app-service-status-link';

const ServiceStatusLink = (props) => {
    const {
        dataCenterLocation,
        formatter,
        footerLink,
        errorLink,
        className,
        icon,
        ...otherProps
    } = props;

    const classnames = classnamesBind.bind(styles);

    const dataCenter = getDataCenter(dataCenterLocation);

    const getServiceStatusUrl = () => {
        const queryString = dataCenter ? `?data-center=${dataCenter}` : '';
        return `//open.concur.com/${queryString}`;
    };

    return (
        <Link
            {...otherProps}
            className={classnames(className, {
                [`${CSS_BLOCK}__footer`]: footerLink,
                [`${CSS_BLOCK}__footer--china`]: footerLink && dataCenter === 'china',
                [`${CSS_BLOCK}__error`]: errorLink,
                [`${CSS_BLOCK}__error-specific`]: errorLink,
            })}
            href={getServiceStatusUrl()}
            target="open"
            data-analytics-json={`{"applicationName":"${footerLink ? 'footer' : 'userProfileMenu'}","elementPath":"service-status","action":"click","elementType":"link"}`}
        >
            {icon}
            {formatter.formattedMessage({ id: `CoreUI.serviceStatus_${!dataCenter ? 'all' : dataCenter}` })}
        </Link>
    );
};

ServiceStatusLink.displayName = 'ServiceStatusLink';

ServiceStatusLink.cssBlock = CSS_BLOCK;

ServiceStatusLink.propTypes = {
    dataCenterLocation: PropTypes.string,
    footerLink: PropTypes.bool,
    errorLink: PropTypes.bool,
    className: PropTypes.string,
    icon: PropTypes.node,
};

export default compose(
    withFormatter,
    withErrorBoundary,
)(ServiceStatusLink);
